module.exports = __webpack_public_path__ + "static/media/IMG_1939.c363e1c1.JPG";